import { render, staticRenderFns } from "./ManifestProductBehaviorStep.vue?vue&type=template&id=ccb1d180&scoped=true&"
import script from "./ManifestProductBehaviorStep.vue?vue&type=script&lang=js&"
export * from "./ManifestProductBehaviorStep.vue?vue&type=script&lang=js&"
import style0 from "./ManifestProductBehaviorStep.vue?vue&type=style&index=0&id=ccb1d180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb1d180",
  null
  
)

export default component.exports